export default __webpack_public_path__ + "static/media/rounded_space.a5e9e0fd.svg";